(() => {
  ('use strict');

  // 定数とキャッシュした要素
  const CLASS_ACTIVE = 'is-active';
  const CLASS_FIXED = 'is-fixed';
  const body = document.body;
  const header = document.querySelector('.l-header');
  const headerHeight = header.offsetHeight;

  const hamburger = {
    trigger: document.getElementById('js-hamburger-trigger'),
    contents: document.querySelector('.l-hamburger-contents'),
    layer: document.querySelector('.l-hamburger-layer'),
    focusTrap: document.getElementById('js-hamburger-focustrap'),
  };

  let isMenuOpen = false;
  let scrollPosition = 0;

  // ハンバーガーメニューの状態管理
  const menuController = {
    close() {
      if (!body.classList.contains(CLASS_FIXED)) return;

      hamburger.trigger.setAttribute('aria-expanded', 'false');
      hamburger.contents.setAttribute('aria-hidden', 'true');
      hamburger.layer.classList.remove(CLASS_ACTIVE);
      body.classList.remove(CLASS_FIXED);
      body.style.top = '';
      window.scrollTo(0, scrollPosition);
      isMenuOpen = false;
    },

    open() {
      hamburger.trigger.setAttribute('aria-expanded', 'true');
      hamburger.contents.setAttribute('aria-hidden', 'false');
      hamburger.layer.classList.add(CLASS_ACTIVE);
      scrollPosition = window.scrollY;
      body.classList.add(CLASS_FIXED);
      body.style.top = `${-scrollPosition}px`;
      isMenuOpen = true;
    },

    toggle() {
      isMenuOpen ? this.close() : this.open();
    },
  };

  // メディアクエリ変更時の処理
  function handleMediaQuery(e) {
    if (e.matches && isMenuOpen) {
      menuController.close();
    }
  }

  // スムーススクロール
  function initSmoothScroll() {
    // js-anchorクラスがついたアンカーリンクのスムーススクロール
    document.querySelectorAll('a.js-anchor').forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;

        // 同ページ内のアンカーリンクかチェック
        let targetId = '';
        if (href.startsWith('#')) {
          // 相対パス (#anchor)
          targetId = href.slice(1);
        } else if (href.includes('#')) {
          // 絶対パスの場合、同一ページかチェック
          const url = new URL(href, window.location.href);
          if (url.origin === window.location.origin && url.pathname === window.location.pathname) {
            targetId = url.hash.slice(1);
          } else {
            return; // 他ページへのリンクなので何もしない
          }
        } else {
          return; // ハッシュがないリンクなので何もしない
        }

        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;

        e.preventDefault();
        menuController.close();
        // ヘッダーの高さを考慮してスクロール
        scrollToTarget(target);
      });
    });
    // URLハッシュがある場合の処理
    handleUrlHash();
  }
  // ターゲット要素へのスムーススクロール関数
  function scrollToTarget(target) {
    const headerElement = document.querySelector('.l-header');
    const headerHeight = headerElement ? headerElement.offsetHeight : 0;
    const pos = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({
      top: pos,
      behavior: 'smooth',
    });
  }
  // URLハッシュ処理
  function handleUrlHash() {
    const urlHash = location.hash;
    if (!urlHash) return;
    const targetId = urlHash.slice(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    // 1. まず即座にブラウザデフォルトのスクロールを防ぐ
    history.replaceState(null, null, ' ');
    // 2. ページ読み込み完了を待つ
    const scrollWhenReady = () => {
      // 画像の読み込み完了も待つ
      Promise.all(
        Array.from(document.images)
          .filter((img) => !img.complete)
          .map(
            (img) =>
              new Promise((resolve) => {
                img.onload = img.onerror = resolve;
              })
          )
      ).then(() => {
        // 少し遅延を入れてからスクロール
        setTimeout(() => {
          scrollToTarget(target);
          // URLを元に戻す
          history.replaceState(null, null, urlHash);
        }, 200);
      });
    };
    if (document.readyState === 'complete') {
      scrollWhenReady();
    } else {
      window.addEventListener('load', scrollWhenReady);
    }
  }

  // スクロールアニメーション
  function initScrollAnimation() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(CLASS_ACTIVE);
            // 一度表示されたら監視を解除する場合
            // observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    document.querySelectorAll('.js-scroll-in').forEach((el) => observer.observe(el));
  }

  const detailsAccordion = () => {
    const details = document.querySelectorAll('.js-details');
    const RUNNING_VALUE = 'running';

    details.forEach((el) => {
      const summary = el.querySelector('.js-summary');
      const content = el.querySelector('.js-content');

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        if (el.dataset.animStatus === RUNNING_VALUE) {
          return;
        }

        if (el.open) {
          el.classList.remove(CLASS_ACTIVE);

          const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
          el.dataset.animStatus = RUNNING_VALUE;

          closingAnim.onfinish = () => {
            el.removeAttribute('open');
            el.dataset.animStatus = '';
          };
        } else {
          el.setAttribute('open', 'true');
          el.classList.toggle(CLASS_ACTIVE);
          const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
          el.dataset.animStatus = RUNNING_VALUE;

          openingAnim.onfinish = () => {
            el.dataset.animStatus = '';
          };
        }
      });
    });
  };

  const openingAnimKeyframes = (content) => [
    {
      height: 0,
      opacity: 0,
    },
    {
      height: `${content.offsetHeight}px`,
      opacity: 1,
    },
  ];

  const closingAnimKeyframes = (content) => [
    {
      height: `${content.offsetHeight}px`,
      opacity: 1,
    },
    {
      height: 0,
      opacity: 0,
    },
  ];

  const animTiming = {
    duration: 400,
    easing: 'ease-out',
  };

  const initReadMore = () => {
    const readmoreTrigger = document.querySelectorAll('.c-button-readmore');

    readmoreTrigger.forEach((e) => {
      const readmoreContents = e.previousElementSibling;

      // テキストの文字数をチェック
      const textLength = readmoreContents.textContent.trim().length;

      // 300文字未満の場合はボタンを非表示にして処理を終了
      if (textLength < 200) {
        e.style.display = 'none';
        readmoreContents.classList.add('is-hidden');
        return;
      }

      e.addEventListener('click', () => {
        readmoreContents.classList.toggle(CLASS_ACTIVE);

        if (readmoreContents.classList.contains(CLASS_ACTIVE)) {
          readmoreContents.style.height = 'auto';
          let h = readmoreContents.offsetHeight;
          readmoreContents.style.height = h + 'px';
          readmoreContents.animate([{ height: '200px' }, { height: h + 'px' }], {
            duration: 300,
          });
          e.textContent = '閉じる';
        } else {
          readmoreContents.style.height = '200px';
          e.textContent = 'もっと見る';
        }
      });
    });
  };

  const toggleTab = () => {
    const tabs = document.querySelectorAll('[role="tab"]');
    const tabList = document.querySelector('[role="tablist"]');

    // 各タブに click イベントハンドラーを追加します
    tabs.forEach((tab) => {
      tab.addEventListener('click', changeTabs);
    });

    // タブリストのタブ間の矢印ナビゲーションを有効にします
    let tabFocus = 0;

    tabList?.addEventListener('keydown', (e) => {
      // 右に移動
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute('tabindex', -1);
        if (e.keyCode === 39) {
          tabFocus++;
          // 最後にいる場合は、最初に移動します
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // 左に移動
        } else if (e.keyCode === 37) {
          tabFocus--;
          // 最初にいる場合は、最後に移動します
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute('tabindex', 0);
        tabs[tabFocus].focus();
      }
    });
  };

  function changeTabs(e) {
    const target = e.target;
    const tabList = target.closest('[role="tablist"]');
    const tabPanels = tabList.nextElementSibling;

    // タブから現在すべての選択状態を取り除きます
    tabList.querySelectorAll('[aria-selected="true"]').forEach((t) => t.setAttribute('aria-selected', false));

    // このタブを選択されたタブとして設定します
    target.setAttribute('aria-selected', true);

    // すべてのタブパネルを非表示にします
    tabPanels.querySelectorAll('[role="tabpanel"]').forEach((p) => p.setAttribute('hidden', true));

    // 選択されたパネルを表示します
    tabPanels.parentNode.querySelector(`#${target.getAttribute('aria-controls')}`).removeAttribute('hidden');
  }

  const modal = () => {
    const dialogOpenButtons = document.querySelectorAll('.c-modal-open-button');
    const dialogCloseButtons = document.querySelectorAll('.c-modal-close-button');

    dialogOpenButtons.forEach((button) => {
      const dialog = document.querySelector(button.dataset.dialog);

      button.addEventListener('click', () => {
        dialog.showModal();
      });

      dialog.addEventListener('click', (el) => {
        if (el.target.closest('.dialog-container') === null) {
          dialog.close();
        }
      });

      // モーダル内のaタグをクリックしたらダイアログを閉じる
      const links = dialog.querySelectorAll('a');
      links.forEach((link) => {
        link.addEventListener('click', () => {
          dialog.close();
        });
      });
    });

    dialogCloseButtons.forEach((button) => {
      const dialog = button.closest('dialog');

      button.addEventListener('click', () => {
        dialog.close();
      });
    });
  };

  // ブランドTOP固定バナー
  const lineTopFixedBanner = document.querySelector('.p-line-top-fixed-banner');

  // 要素が存在する場合のみ処理を実行
  if (lineTopFixedBanner) {
    function checkReservationButtonVisibility() {
      if (isMenuOpen) return; // メニューが開いているときはスクロール判定をスキップ

      const scrollY = window.scrollY || window.pageYOffset;
      const footer = document.querySelector('.l-footer');
      const footerRect = footer.getBoundingClientRect();

      // 200pxスクロールしたかチェック
      const isScrolledEnough = scrollY > 200;

      // フッターが表示されているかチェック
      const isFooterVisible = footerRect.top < window.innerHeight;

      // 200pxスクロール済み かつ フッターが表示されていない場合に is-show を付与
      if (isScrolledEnough && !isFooterVisible) {
        lineTopFixedBanner.classList.add('is-show');
      } else {
        lineTopFixedBanner.classList.remove('is-show');
      }
    }

    // 固定ボタンの処理を関数化
    function fixedBanner() {
      window.addEventListener('scroll', function () {
        if (!isMenuOpen) {
          // メニューが開いていない時だけスクロール処理を行う
          checkReservationButtonVisibility();
        }
      });
    }

    // 初期化
    fixedBanner();
  }

  // イベントリスナーの設定
  function setupEventListeners() {
    // ハンバーガーメニュー関連
    hamburger.trigger.addEventListener('click', () => menuController.toggle());
    hamburger.layer.addEventListener('click', () => menuController.close());
    hamburger.focusTrap.addEventListener('focus', () => hamburger.trigger.focus());

    // ESCキーでメニューを閉じる
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') menuController.close();
    });

    // メディアクエリ変更時の処理
    const mediaQuery = window.matchMedia('(min-width: 769px)');
    mediaQuery.addEventListener('change', handleMediaQuery);
    handleMediaQuery(mediaQuery);
  }

  // 初期化
  document.addEventListener('DOMContentLoaded', () => {
    setupEventListeners();
    initSmoothScroll();
    initScrollAnimation();
    initReadMore();
    detailsAccordion();
    toggleTab();
    modal();
  });
})();
